import React from 'react';

/**
 * Status line for principal-email syntax only. Do not use for
 * "Enter {question} to continue" on ordinary wizard steps.
 */
export default function WizardContinueHint({ reason }) {
  if (!reason) return null;
  return <p className="wizard-continue-hint" role="status">{reason}</p>;
}
